module.exports = __webpack_public_path__ + "static/img/img_pass@2x.1776169966151.png";